import {isEmpty, isValidPhone, isValidPostalCode} from "./helper";
import i18next from "../i18n";

/**
 * valida i dati di un form
 * @param data oggetto con i dati da validare
 * @param fields {[{field:string,error:string,validation:function(data):string|null|boolean}|{field:string}|{field:string,error:string}]} informazioni su come effettuare la validazione, il controllo di default è quello sul required. validation può ritornare o l'errore da mostrare oppure un valore booleano
 * @returns {[valid:boolean,error:{}]}//flag per definire se è valido, oggetto con messaggi di errore
 */
export function validateForm(data, fields) {
    let errors = {};
    let isValid = true;
    fields.forEach((item) => {
        let element = data[item.field];
        if (!item.validation && isEmpty(element)) {
            errors[item.field] = item.error || i18next.t('mandatoryField');
            isValid = false;
        }
        if (typeof item.validation === 'function') {
            let valid = item.validation(data);
            if (typeof valid === 'boolean' && !valid) {
                errors[item.field] = item.error || i18next.t('mandatoryField');
                isValid = false;
            } else if (typeof valid === 'string') {
                errors[item.field] = valid;
                isValid = false;
            }
        }
    });
    return [errors, isValid];
}

/**
 *
 * @param data oggetto data con tutti i campi del form
 * @returns {({}|boolean)[]}
 */
export function validateVendorData(data) {

    return validateForm(
        data,
        [
            {
                field: 'businessName',
            },
            {
                field: 'address',
                validation: (data) => !((isEmpty(data.address) || isEmpty(data.number) || isEmpty(data.postalCode) || isEmpty(data.city) || isEmpty(data.province) || isEmpty(data.country)))
            },
            {
                field: 'phone',
                validation: (data) => isValidPhone(data.phone),
                error: i18next.t('invalidPhone')
            },
            {
                field: 'vatNumber',
            },
            {
                field: 'postalCode',
                validation: (data) => isValidPostalCode(data.postalCode),
                error: i18next.t('postalCodeNotValid')
            },
        ]
    );
    // if(!isValidVat(data.vatNumber)){
    //     errors.vatNumber = INVALID_VAT;
    //     isValid = false;
    // }
    // if(!isValidIBAN(data.iban)){
    //     errors.iban = INVALID_IBAN;
    //     isValid = false;
    // }
}

/**
 * valida nome,email,password
 * @param newData
 * @returns {({}|boolean)[]}
 * @private
 */
export function validateEmailPass(newData) {
    return validateForm(
        newData,
        [
            {
                field: 'firstName',
            },
            {
                field: 'lastName',
            },
            {
                field: 'email',
            },
            {
                field: 'newPassword',
            },
            {
                field: 'repeatPassword',
                validation: (data) => {
                    return data.newPassword === data.repeatPassword;
                },
                error: i18next.t('passwordNotMatch')
            },
            {
                field: 'lastName'
            }
        ]
    );
}